module.exports = __webpack_public_path__ + "static/media/2.a0a1b6dc.jpg";